
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VenuesDetailPage from "../pages/venues-detail/page";
import ArtistsDetailPage from "../pages/artists-detail/page";
import VenuesListPage from "../pages/venues-list/page";
import SchedulePage from "../pages/schedule/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/venues-detail",
    element: <VenuesDetailPage />,
  },
  {
    path: "/venues-list",
    element: <VenuesListPage />,
  },
  {
    path: "/artists-detail",
    element: <ArtistsDetailPage />,
  },
  {
    path: "/schedule",
    element: <SchedulePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
